import { mergeFragments } from "../../mergeFragments";
import base from "./base";
import pages1 from "./pages1";
import pages2 from "./pages2";
import receipts from "./receipts";
import manageBooking from "./manageBooking";
import promo from "./promo";
import giftcard from "./giftcard";
import clientAuth from "./clientAuth";
import consultCheckout from "./consultCheckout";
import breakdown from "./breakdown";
import openHoursBooking from "./openHoursBooking";
import messages from "./messages";
import reviews from "./reviews";
import pathways from "./pathways";
import learnQuiz from "./learnQuiz";
// crm-module BEGIN C2.03 (lane F2) — public session-pack purchase
import packs from "./packs";
// crm-module END
// crm-module BEGIN C2.06 (lane F1) — Confirm / Unsubscribe landing pages
import confirmBooking from "./confirmBooking";
import unsubscribe from "./unsubscribe";
// crm-module END
// Marketing opt-in at booking/checkout + the account page's email preferences
import marketingOptIn from "./marketingOptIn";

export default mergeFragments([base, pages1, pages2, receipts, manageBooking,
  promo, giftcard, clientAuth, consultCheckout, breakdown, openHoursBooking,
  messages, reviews, pathways, learnQuiz,
  // crm-module BEGIN C2.03 (lane F2)
  packs,
  // crm-module END
  // crm-module BEGIN C2.06 (lane F1)
  confirmBooking, unsubscribe,
  // crm-module END
  marketingOptIn,
]);
